"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _utils = require("../../utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function KActivityBanner() {
  (0, _react.useEffect)(function () {
    (0, _utils.windowAddEventListener)(function () {
      (0, _utils.scaleAnimation)('activity-animation-banner');
    }, 1);
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "activity-banner-logo",
    id: "activity-animation-banner"
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "activity-banner-top"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: "activity-img-1",
    src: "https://staticintl.cloudcachetci.com/cms/backend-cms/IUCW539_banner-activity-yellow.png"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "activity-banner-center"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: "https://staticintl.cloudcachetci.com/cms/backend-cms/UwA7720_banner-activity-bg2.png",
    alt: ""
  }))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("img", {
    className: "activity-img-2",
    src: "https://staticintl.cloudcachetci.com/cms/backend-cms/2QsW716_banner-activity-blue.png"
  }))));
}

var _default = KActivityBanner;
exports["default"] = _default;